import { render, staticRenderFns } from "./ConfirmCellPhone.vue?vue&type=template&id=5c45a15e&scoped=true&"
import script from "./ConfirmCellPhone.vue?vue&type=script&lang=js&"
export * from "./ConfirmCellPhone.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCellPhone.vue?vue&type=style&index=0&id=5c45a15e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c45a15e",
  null
  
)

export default component.exports